/** 要素の種別。行のバッジに出し、表だけに出す設定（入りきらないとき・余った行）の判定に使う。 */
export type SlideShapeKind =
    | "body"
    | "table"
    | "chart"
    | "diagram"
    | "image"
    | "shape"
    | "group"
    | "line"
    | "other";

/**
 * 図形の型から種別を決める。
 *
 * **`GeometricShape` を落とさない。** 以前は `TextBox` と `Placeholder` だけを本文と見なし、
 * 残りを「その他」へ畳んでいた。ところで PowerPoint で図形として描いた枠はすべて
 * `GeometricShape` で、実物のフォーマットは文字入りの枠を四角で作っている。実テンプレの
 * 最上位 1,170 図形のうち 612 個が `GeometricShape`、種別に畳むと 793 個（68%）が「その他」
 * になり、そのうち 730 個には文字が入っていた。本番の薬局テンプレでも 519 個のうち 370 個
 * （71%）が「その他」だった。バッジが枠の当たりを付ける役に立たない状態だったので、
 * 図形・グループ・線を分けて呼ぶ（記録 70）。
 *
 * 見出しは判別できない。`placeholderFormat.type` は本番環境（Office 16.0.20326 /
 * PowerPointApi 1.10 上限）でまとめ読みでも 1 件ずつでも `GeneralException` になり
 * 取得できなかったため、Title と Body を区別する手段が無い。Placeholder は本文として扱う。
 *
 * 引数は `PowerPoint.ShapeType` の値（`Unsupported` / `Image` / `GeometricShape` / `Group` /
 * `Line` / `Table` / `Callout` / `Chart` / `ContentApp` / `Diagram` / `Freeform` / `Graphic` /
 * `Ink` / `Media` / `Model3D` / `Ole` / `Placeholder` / `SmartArt` / `TextBox`）である。
 * 版によって値が増えうるので、知らない値は「その他」へ落とす。
 */
export function toKind(shapeType: string): SlideShapeKind {
    if (shapeType === "Table") return "table";
    if (shapeType === "Chart") return "chart";
    if (shapeType === "Diagram" || shapeType === "SmartArt") return "diagram";
    if (shapeType === "Image" || shapeType === "Media" || shapeType === "Model3D") return "image";
    if (shapeType === "TextBox" || shapeType === "Placeholder") return "body";
    // 図形として描いた枠。文字が入っているものが大半で、実務ではこれが主役になる。
    if (shapeType === "GeometricShape" || shapeType === "Freeform" || shapeType === "Callout")
        return "shape";
    if (shapeType === "Group") return "group";
    if (shapeType === "Line") return "line";
    return "other";
}
